import AddressSourceType from 'sources/sourceTypes/Address';
import { Address } from 'types';

export const toSource = (_obj: Address): AddressSourceType =>
  new AddressSourceType();

export const toType = (sourceObj: AddressSourceType): Address => {
  const address = new Address();

  address.id = sourceObj.id;
  address.city = sourceObj.city || '';
  address.state = sourceObj.state || '';

  return address;
};
